import {Component, OnInit} from '@angular/core';
import {WebNavigationService} from '../../../navigation.service';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-usuarios-submenu',
    templateUrl: './usuarios-submenu.component.html',
    styleUrls: ['./usuarios-submenu.component.scss'],
})
export class UsuariosSubmenuComponent implements OnInit {

    constructor(private navigationService: WebNavigationService, private router: Router, private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    selectedPaymentOption(paymentOption) {
        if (paymentOption == 0)
            this.router.navigate(['usuarios/ganalottodo'], {relativeTo: this.activatedRoute});
        else if (paymentOption == 1)
            this.router.navigate(['usuarios/ppap'], {relativeTo: this.activatedRoute});
    }

    get selectedOption() {
        return this.navigationService.selectedOption;
    }

    get expanded() {
        return this.navigationService.expanded;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/usuarios/usuarios-submenu/usuarios-submenu.component.ts